import { Printer } from 'lucide-react';
import { LeadFormDialog } from './LeadFormDialog';
import { COLORS } from '@/constants/calculator';

const PRINT_BTN_STYLE = {
  borderColor: COLORS.PURPLE,
  color: COLORS.PURPLE,
  backgroundColor: 'transparent',
};

const handlePrintMouseEnter = (e) => {
  e.currentTarget.style.backgroundColor = COLORS.PURPLE;
  e.currentTarget.style.color = '#ffffff';
};

const handlePrintMouseLeave = (e) => {
  e.currentTarget.style.backgroundColor = 'transparent';
  e.currentTarget.style.color = COLORS.PURPLE;
};

const handlePrint = () => {
  window.print();
};

export const ActionButtons = ({ values, calculated }) => (
  <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center no-print">
    <button
      onClick={handlePrint}
      className="inline-flex items-center justify-center gap-2 font-bold text-base px-6 py-3 border-2 transition-all duration-200"
      style={PRINT_BTN_STYLE}
      onMouseEnter={handlePrintMouseEnter}
      onMouseLeave={handlePrintMouseLeave}
      data-testid="print-pdf-btn"
    >
      <Printer className="h-5 w-5" />
      DOWNLOAD PDF
    </button>

    <LeadFormDialog values={values} calculated={calculated} />
  </div>
);
